// Globaler Helfer fuer <input type="range">: setzt --range-fill (0-100%)
// auf jedem Slider, damit der Track LINKS vom Daumen in Accent gefuellt
// ist. WebKit/Blink haben kein natives ::progress fuer range -- der Fill
// kommt dort aus einem linear-gradient in app.css, gespeist aus dieser
// Variable. Firefox nutzt zusaetzlich ::-moz-range-progress (nativ).
//
// Eine einzige delegierte input-Subscription + ein MutationObserver
// decken ALLE Slider im Dashboard ab (auch spaeter gemountete), ohne
// dass eine Call-Site etwas tun muss. Bewusst kein pro-Slider-Svelte-
// Binding -- der Look soll rein aus dem CSS/diesem Modul kommen.

function fillFor(el: HTMLInputElement): number {
  const min = Number(el.min || "0");
  const max = Number(el.max || "100");
  const val = Number(el.value);
  if (!isFinite(min) || !isFinite(max) || max <= min) return 0;
  const pct = ((val - min) / (max - min)) * 100;
  return Math.min(100, Math.max(0, pct));
}

function paint(el: HTMLInputElement): void {
  el.style.setProperty("--range-fill", fillFor(el) + "%");
}

function isRange(t: EventTarget | null): t is HTMLInputElement {
  return t instanceof HTMLInputElement && t.type === "range";
}

function scan(root: ParentNode): void {
  root
    .querySelectorAll?.<HTMLInputElement>('input[type="range"]')
    .forEach(paint);
}

let started = false;

export function initRangeFill(): void {
  if (started) return;
  started = true;

  // User-Drags: input bubbelt, eine Subscription reicht fuer alle Slider.
  document.addEventListener(
    "input",
    (e) => {
      if (isRange(e.target)) paint(e.target);
    },
    true,
  );

  // Neu gemountete Slider (SPA-Navigation) + programmatische value-Attr-
  // Aenderungen initial fuellen.
  const mo = new MutationObserver((muts) => {
    for (const m of muts) {
      if (m.type === "attributes") {
        if (isRange(m.target)) paint(m.target as HTMLInputElement);
        continue;
      }
      for (const n of m.addedNodes) {
        if (!(n instanceof HTMLElement)) continue;
        if (isRange(n)) paint(n);
        scan(n);
      }
    }
  });
  mo.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["value", "min", "max"],
  });

  scan(document);
}
